import { ServiceTypeEnum, RiderVehicleTypeEnum } from 'app/models';

export class ServiceAndVehicleTypeModel {
    public static RiderVehicleTypeList: Array<any> = [
        { serviceType: null, vehicleType: null, name: 'All' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Moto, name: 'Ride - Moto' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Sedan, name: 'Ride - Car' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.SUV, name: 'Ride - SUV' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.EVCar, name: 'Ride - EV Car' },
        { serviceType: ServiceTypeEnum.ScanAndRide, vehicleType: null, name: 'Scan & Ride' },
        { serviceType: ServiceTypeEnum.Delivery, vehicleType: RiderVehicleTypeEnum.Courier, name: 'Delivery - Courier' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.PetTaxi, name: 'Ride - Pet Taxi' }
    ];

    public static GetServiceAndVehicleTypeList: Array<any> = [
        { serviceType: null, vehicleType: null, name: 'All' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Moto, name: 'Ride - 2W - Moto' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Sedan, name: 'Ride - 4W - Sedan' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.SUV, name: 'Ride - 4W - SUV' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.EVCar, name: 'Ride - 4W - EV Car' }
    ];

    public static RideAndSendServiceAndVehicleTypeList: Array<any> = [
        { value: null, name: null, label: 'All' },
        { value: ServiceTypeEnum.Ride, name: RiderVehicleTypeEnum.Moto, label: 'Ride - Moto' },
        { value: ServiceTypeEnum.Ride, name: RiderVehicleTypeEnum.Sedan, label: 'Ride - Sedan' },
        { value: ServiceTypeEnum.Ride, name: RiderVehicleTypeEnum.SUV, label: 'Ride - SUV' },
        { value: ServiceTypeEnum.Delivery, name: RiderVehicleTypeEnum.Moto, label: 'Send - Moto' },
        { value: ServiceTypeEnum.Delivery, name: RiderVehicleTypeEnum.Sedan, label: 'Send - Sedan' },
        { value: ServiceTypeEnum.Delivery, name: RiderVehicleTypeEnum.SUV, label: 'Send - SUV' },
        { value: ServiceTypeEnum.Delivery, name: RiderVehicleTypeEnum.EVCar, label: 'Send - EV Car' }
    ];

    public static GetServiceTypeAndVehicleType(serviceType: ServiceTypeEnum, riderVehicleType: RiderVehicleTypeEnum): any {
        let result = {};

        if (serviceType === ServiceTypeEnum.Ride && riderVehicleType === RiderVehicleTypeEnum.Moto) {
            result = { name: 'Ride - Moto', img: '/Content/xpress-app/images/moto.svg' };
            return result;
        } else if (serviceType === ServiceTypeEnum.Ride && riderVehicleType === RiderVehicleTypeEnum.Sedan) {
            result = { name: 'Ride - Sedan', img: '/Content/xpress-app/images/car-red.svg' };
            return result;
        } else if (serviceType === ServiceTypeEnum.Ride && riderVehicleType === RiderVehicleTypeEnum.SUV) {
            result = { name: 'Ride - SUV', img: '/Content/xpress-app/images/SUV.svg' };
            return result;
        } else if (serviceType === ServiceTypeEnum.Ride && riderVehicleType === RiderVehicleTypeEnum.EVCar) {
            result = { name: 'Ride - EV Car', img: '/Content/xpress-app/images/car-red.svg' };
			return result;
		} else if (serviceType === ServiceTypeEnum.Taxi && riderVehicleType === RiderVehicleTypeEnum.Taxi) {
			result = { name: 'Taxi - Taxi', img: '/Content/xpress-app/images/car-taxi.svg' };
			return result;
		} else if (serviceType === ServiceTypeEnum.Ride && riderVehicleType === RiderVehicleTypeEnum.ETrike) {
            result = { name: 'Ride - E-Trike', img: '/Content/xpress-app/images/etrike.svg' };
            return result;
        } else if (serviceType === ServiceTypeEnum.Ride && riderVehicleType === RiderVehicleTypeEnum.Van) {
            result = { name: 'Ride - Van', img: '/Content/xpress-app/images/van.svg' };
            return result;
        } else if (serviceType === ServiceTypeEnum.Ride && riderVehicleType === RiderVehicleTypeEnum.Minibus) {
            result = { name: 'Ride - Minibus', img: '/Content/xpress-app/images/minibus.svg' };
            return result;
        } else if (serviceType === ServiceTypeEnum.Ride && riderVehicleType === RiderVehicleTypeEnum.Multicab) {
            result = { name: 'Ride - Multicab', img: '/Content/xpress-app/images/multicab.svg' };
            return result;
        }
    }

    public static GetServiceTypeAndVehicleTypeForAppRogressList: Array<any> = [
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Moto, name: 'Ride - Moto', img: '/Content/xpress-app/images/moto.svg' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Sedan, name: 'Ride - Car', img: '/Content/xpress-app/images/car-red.svg' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.SUV, name: 'Ride - SUV', img: '/Content/xpress-app/images/SUV.svg' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.EVCar, name: 'Ride - EV Car', img: '/Content/xpress-app/images/car-red.svg' },
		{ serviceType: ServiceTypeEnum.Taxi, vehicleType: RiderVehicleTypeEnum.Taxi, name: 'Taxi - Taxi', img: '/Content/xpress-app/images/car-taxi.svg' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.ETrike, name: 'Ride - E-Trike', img: '/Content/xpress-app/images/etrike.svg' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Van, name: 'Ride - Van', img: '/Content/xpress-app/images/van.svg' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Minibus, name: 'Ride - Minibus', img: '/Content/xpress-app/images/minibus.svg' },
        { serviceType: ServiceTypeEnum.Ride, vehicleType: RiderVehicleTypeEnum.Multicab, name: 'Ride - Multicab', img: '/Content/xpress-app/images/multicab.svg' }
    ];
}
